module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1tZXNzYWdlLWJhci1jb250ZWluZXJ7DQogICAgZGlzcGxheTogZmxleDsNCiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWFyb3VuZDsNCiAgICBhbGlnbi1pdGVtczogY2VudGVyOw0KICAgIGJhY2tncm91bmQtY29sb3I6ICRncmV5LTUwOw0KICAgIG1pbi1oZWlnaHQ6IDg0cHg7DQogICAgd2lkdGg6IDEwMCU7DQp9"


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/NewMessageBar/NewMessageBar.scss
// module id = 2495
// module chunks = 0